import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '@opallabs/api/v3'

type RequestAttributes =
  OpalApiRequestBody<'CreateMomentScheduleV3'>['data']['attributes']
type RequestRelationships =
  OpalApiRequestBody<'CreateMomentScheduleV3'>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'moment_schedule'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultAttributes: OptionalAttributes = {
  day_segment: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  end_at: null,
  should_end_at_cascade: false,
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'moment_schedule'> => {
  return {
    id: uuidv4(),
    type: 'moment_schedule',
    attributes: {
      ...defaultAttributes,
      ...attributes,
    },
    relationships: {
      ...relationships,
    },
  }
}
